import React from 'react'

const Term = () => {
    return (
        <div
            style={{
                textAlign: "left",
                width: "100%",
                maxWidth: "1200px",
                margin: "0 auto",
                fontFamily: "Arial, sans-serif",
            }}
        >
            <h1
                style={{
                    borderBottom: "2px solid #ddd",
                    paddingBottom: "10px",
                    marginBottom: "20px",
                    fontSize: "28px",
                }}
            >
                T&C (Terms and Conditions)
            </h1>

            <div
                style={{
                    display: "flex",
                    gap: "30px",
                    marginTop: "10px",
                }}
            >
                {/* LEFT COLUMN */}
                <div style={{ flex: 1 }}>
                    {[
                        {
                            title: "Discount Distribution:",
                            text: "You will receive a discount coupon via your registered email or phone number upon successful registration.",
                        },
                        {
                            title: "Organization’s Right:",
                            text: "The company reserves the right to change, modify, or cancel the discount coupon scheme at any time without prior notice.",
                        },
                        {
                            title: "Provide Correct Information:",
                            text: "You are required to provide accurate and complete details during registration. Any incorrect, fake, or duplicate information will result in cancellation of the discount.",
                        },
                        {
                            title: "Using Your Coupon:",
                            text: "The coupon must be shown to our representative at the billing counter between 10:00 AM to 9:00 PM during event days at the time of final payment.",
                        },
                        {
                            title: "Minimum Purchase Requirement:",
                            text: "The discount is applicable only on purchases above ₹10,000. This coupon is valid for one-time use only.",
                        },
                    ].map((item, index) => (
                        <div
                            key={index}
                            style={{
                                border: "1px solid #e5e5e5",
                                padding: "15px",
                                borderRadius: "8px",
                                marginBottom: "20px",
                                backgroundColor: "#fafafa",
                                boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                            }}
                        >
                            <h2 style={{ fontSize: "18px", marginBottom: "8px" }}>{item.title}</h2>
                            <p style={{ fontSize: "14px", color: "#555" }}>{item.text}</p>
                        </div>
                    ))}
                </div>

                {/* RIGHT COLUMN */}
                <div style={{ flex: 1 }}>
                    {[
                        {
                            title: "Minimum Purchase Requirement:",
                            text: "The discount is applicable only on purchases above ₹5,000. This coupon can be used only once.",
                        },
                        {
                            title: "Product Applicability:",
                            text: "The coupon is valid on all Elite Fashion Bazaar products during exhibition hours from 10:00 AM to 10:00 PM.",
                        },
                        {
                            title: "Non-Combination:",
                            text: "This coupon cannot be clubbed with any other ongoing offer, deal, or promotion.",
                        },
                        {
                            title: "Bill Payment:",
                            text: "The discount will be applied only on the final bill amount before taxes.",
                        },
                        {
                            title: "Customer Service:",
                            text: "For any queries related to the discount coupon, please contact our customer support through Instagram.",
                        },
                        {
                            title: "Validity:",
                            text: "This coupon is valid only for the specific exhibition dates mentioned.",
                        },
                    ].map((item, index) => (
                        <div
                            key={index}
                            style={{
                                border: "1px solid #e5e5e5",
                                padding: "15px",
                                borderRadius: "8px",
                                marginBottom: "20px",
                                backgroundColor: "#fafafa",
                                boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                            }}
                        >
                            <h2 style={{ fontSize: "18px", marginBottom: "8px" }}>{item.title}</h2>
                            <p style={{ fontSize: "14px", color: "#555" }}>{item.text}</p>
                        </div>
                    ))}
                </div>
            </div>
        </div>

    )
}

export default Term
